/**
 * @internal
 */
export var json = function (response) {
    if (response.status === 204 /* NO_CONTENT */) {
        return Promise.resolve(null);
    }
    return response.json();
};
